export default __webpack_public_path__ + "static/media/tun.1572881f.svg";